<template>
  <reason-list :level="2" />
</template>

<script>
import ReasonList from "./components/ReasonList.vue";

export default {
  name: "ClaimAccidentReasonLevelTwo",
  components: { ReasonList }
};
</script>
